import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { DoubleArrow, Check } from '@mui/icons-material';
import { popOver } from '../../assets/templates';
import validateRequiredFields, { toInteger } from '../../utilities';
import TimeSlots from '../ui/TimeSlots';
import FlipSwitch from '../ui/FlipSwitch';
/* eslint max-len: ["error", { "code": 150 }] */
/* eslint no-underscore-dangle: ["off"] */

const SelectWorkerCostView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
}) => {
  const [validateSubmit, setValidateSubmit] = useState(false);
  const [isTimeSlotVisible, setIsTimeSlotVisible] = useState(false);
  const [isDisabled, setIsDisabled] = useState({
    monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: true,
  });
  const [entriesValues, setEntriesValue] = useState({
    monday: '09:00', tuesday: '09:00', wednesday: '09:00', thursday: '09:00', friday: '09:00', saturday: '09:00', sunday: '00:00',
  });
  const [exitValues, setExitValues] = useState({
    monday: '18:00', tuesday: '18:00', wednesday: '18:00', thursday: '18:00', friday: '18:00', saturday: '12:00', sunday: '00:00',
  });

  /**
 * Obtiene los dias que existen en el mes
 */
  const daysInMonth = (day) => {
    const m = moment()._locale._months.indexOf(moment().format('MMMM')) + 1;
    const y = moment().format('YYYY');
    const days = new Date(y, m, 0).getDate();
    const numberOfDaysInMonth = [day + 1 - (new Date(`${m}/01/${y}`).getDay())];
    for (let i = numberOfDaysInMonth[0] + 7; i < days + 1; i += 7) {
      numberOfDaysInMonth.push(i);
    }
    return numberOfDaysInMonth;
  };

  const [workedDays, setWorkedDays] = useState({
    monday: daysInMonth(1).length,
    tuesday: daysInMonth(2).length,
    wednesday: daysInMonth(3).length,
    thursday: daysInMonth(4).length,
    friday: daysInMonth(5).length,
    saturday: daysInMonth(6).length,
    sunday: daysInMonth(7).length,
  });

  useEffect(() => {
    if (calculationsData?.worker?.workedHoursPerMonth <= 0
      || calculationsData?.worker?.employeeSalaryPerMonth <= 0) return;

    let workedHours = 0;
    if (calculationsData.design?.typeOfWork === 'cut-and-engrave') {
      workedHours = ((calculationsData.design.engraveWorkTime || 0) + (calculationsData.design?.cutWorkTime || 0)) / 60;
    } else {
      workedHours = (calculationsData.design?.cutWorkTime || 0) / 60;
    }

    setCalculationsData({
      ...calculationsData,
      worker: {
        ...calculationsData.worker,
        productionCostPerDesign: ((calculationsData.worker?.employeeSalaryPerMonth || 0)
        / (calculationsData.worker?.workedHoursPerMonth || 0)) * workedHours,
      },
      design: {
        ...calculationsData.design,
        costPerDesign: calculationsData.design.costPerDesign
        + (workedHours * calculationsData.machine.pipe.costPerHour),
      },
    });
  }, [calculationsData?.worker?.workedHoursPerMonth,
    calculationsData?.worker?.employeeSalaryPerMonth]);

  useEffect(() => {
    // Calcula las horas laborales mediante el TIMESLOT, para que el usuario pueda obtenerlo de manera sencilla
    if (!isTimeSlotVisible) return;
    const entryWorkTime = document.querySelectorAll('input[name="entry-work-time"]');
    const exitWorkTime = document.querySelectorAll('input[name="exit-work-time"]');
    const monthWorkedDays = document.querySelectorAll('input[name="worked-days"]');

    let totalHours = 0;
    entryWorkTime.forEach((entry, index) => {
      // se suman las horas y los minutos siempre y cuando sea laboral
      if (!entry.disabled) {
        const entryHour = Number(entry.value.split(':')[0]) + (Number(entry.value.split(':')[1]) / 60);
        const exitHour = Number(exitWorkTime[index].value.split(':')[0])
        + (Number(exitWorkTime[index].value.split(':')[1]) / 60);

        totalHours += Math.abs(exitHour - entryHour) * Number(monthWorkedDays[index].value);
      }
    });
    setCalculationsData({
      ...calculationsData,
      worker: {
        ...calculationsData.worker,
        workedHoursPerMonth: totalHours,
      },
    });
  }, [workedDays, exitValues, isDisabled, entriesValues, isTimeSlotVisible]);

  useEffect(() => {
    setValidateSubmit(validateRequiredFields(document.querySelectorAll('[required]')));
  }, [calculationsData.worker]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setView(view + 1);
      }}
      className="main-container"
      style={{ position: 'relative' }}
    >

      <button
        onClick={() => setView(view - 1)}
        id="button"
        className="simple-button"
        type="button"
        style={{ position: 'absolute', top: '0', left: '0' }}
      >
        <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />
        Paso anterior
      </button>

      {calculationsData?.worker?.productionCostPerDesign > 0
      && (
        <button
          id="button"
          className="simple-button"
          type="submit"
          data-available={validateSubmit}
          data-disabled={!validateSubmit}
          style={{ position: 'absolute', top: '0', right: '0' }}
        >
          <DoubleArrow />
          Siguiente paso
        </button>
      )}

      <div className="appear item-container icon-wrapper">
        <p style={{ margin: '0' }}>
          {(calculationsData?.worker?.employeeSalaryPerMonth > 0)
            && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
          Pago mensual del operador (
          {calculationsData.currentCurrency.currencyCode}
          )
        </p>
        <div data-title={popOver[32]}>
          <img
            alt="icon"
            src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
          />
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <input
            placeholder="8000"
            style={{ padding: '3px 80px 3px 25px' }}
            className="select"
            type="number"
            required
            value={toInteger(calculationsData?.worker?.employeeSalaryPerMonth, 2) || ''}
            onChange={(e) => setCalculationsData({
              ...calculationsData,
              worker: {
                ...calculationsData.worker,
                employeeSalaryPerMonth: Number(e.target.value),
              },
            })}
          />
          <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
        </div>

        {(calculationsData?.worker?.employeeSalaryPerMonth > 0)
        && (
        <div className="appear">
          <div className="aligned-items" style={{ justifyContent: 'space-between', marginTop: '20px' }}>
            <p style={{ margin: '0' }}>
              {(calculationsData?.worker?.workedHoursPerMonth > 0)
                && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
              Horas de trabajo mensuales
            </p>
            <div style={{ display: 'flex', alignItems: 'inherit' }}>
              <p style={{ margin: '0 10px 0 0' }}>
                Seleccionar horario
              </p>
              <FlipSwitch isOn={!isTimeSlotVisible} setIsOn={(value) => setIsTimeSlotVisible(!value)} />
            </div>
          </div>
          <div data-title={popOver[33]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              placeholder="180"
              style={{ padding: '3px 80px 3px 25px' }}
              className="select"
              type="number"
              required
              value={toInteger(calculationsData?.worker?.workedHoursPerMonth, 2) || ''}
              onChange={(e) => setCalculationsData({
                ...calculationsData,
                worker: {
                  ...calculationsData.worker,
                  workedHoursPerMonth: Number(e.target.value),
                },
              })}
            />
            <p className="end-input-icon">horas</p>
          </div>
        </div>
        )}
      </div>

      {isTimeSlotVisible
      && (
        <TimeSlots
          workedDays={workedDays}
          isDisabled={isDisabled}
          entriesValues={entriesValues}
          exitValues={exitValues}
          setWorkedDays={setWorkedDays}
          setIsDisabled={setIsDisabled}
          setEntriesValue={setEntriesValue}
          setExitValues={setExitValues}
        />
      )}

      {calculationsData?.worker?.productionCostPerDesign > 0
      && (
      <div className="appear item-container-contrast mr-t-0">
        <div className="aligned-items icon-wrapper">
          <div className="icon-wrapper">
            <p>
              Costo por hora del operador (
              {calculationsData.currentCurrency.currencyCode}
              )
            </p>
            <div data-title={popOver[34]}>
              <img
                alt="icon"
                src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
              />
            </div>
          </div>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              className="select"
              type="number"
              disabled
              readOnly
              value={calculationsData?.worker?.productionCostPerDesign.toFixed(2) || 0}
            />
            <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
          </div>
        </div>
      </div>
      )}

    </form>
  );
};

SelectWorkerCostView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    currentCurrency: PropTypes.shape({
      currency: PropTypes.string,
      currencyCode: PropTypes.string,
      country: PropTypes.string,
      symbol: PropTypes.string,
    }),
    machine: PropTypes.shape({
      name: PropTypes.string,
      witdhCut: PropTypes.number,
      lengthCut: PropTypes.number,
      pipe: PropTypes.shape({
        pipeName: PropTypes.string,
        durability: PropTypes.number,
        price: PropTypes.number,
        costPerHour: PropTypes.number,
      }),
    }),
    worker: PropTypes.shape({
      productionCostPerDesign: PropTypes.number,
      employeeSalaryPerMonth: PropTypes.number,
      workedHoursPerMonth: PropTypes.number,
    }),
    design: PropTypes.shape({
      typeOfWork: PropTypes.string,
      engraveWorkTime: PropTypes.number,
      cutWorkTime: PropTypes.number,
      costPerDesign: PropTypes.number,
    }),
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectWorkerCostView);
